export default "__VITE_ASSET__Dw$dwrpt__"